import { useIntl } from 'react-intl';
import { Stack, Typography } from '@rossum/ui/material';

type EmptyViewsListProps = {
  searchResult: string;
};

export const EmptyViewsList = ({ searchResult }: EmptyViewsListProps) => {
  const intl = useIntl();
  return (
    <Stack
      sx={{
        flexGrow: 1,
        alignItems: 'center',
        justifyContent: 'center',
        px: 1,
        textAlign: 'center',
      }}
    >
      <Typography variant="h6" color="text.secondary">
        {intl.formatMessage({
          id: 'containers.savedViews.emptyList.title',
        })}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {searchResult
          ? intl.formatMessage(
              { id: 'containers.savedViews.emptyList.noResults' },
              { searchResult }
            )
          : intl.formatMessage({
              id: 'containers.savedViews.emptyList.description',
            })}
      </Typography>
    </Stack>
  );
};
